import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResidentPatchResolver } from './resitent-patch.resolver';
import { AnnouncementResolver } from './announcement.resolver';
import { AnnouncementWebsitesResolver } from './announcement-websites.resolver';
import { AnnouncementRulesResolver } from './announcement-rules.resolver';
import { StripeAccountResolver } from './stripe-account.resolver';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [],
    providers: [
        ResidentPatchResolver,
        AnnouncementResolver,
        AnnouncementWebsitesResolver,
        AnnouncementRulesResolver,
        StripeAccountResolver
    ]
})
export class ResolversModule {
}



// WEBPACK FOOTER //
// /app/src/app/resolvers/resolvers.module.ts